import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PolicyValueChart = ({ chartData, portalSettings }) => {
    const [legendTooltip, setLegendTooltip] = useState({ show: false, x: 0, y: 0, label: '', value: 0 });

    // Extract dynamic labels and values
    const labels = chartData.map(item => item.label);
    const values = chartData.map(item => 
         parseFloat(item.value.toString().replace('%', '').replace(',', '').replace('$', '')) || 0
    );

    const backgroundColors = [
        portalSettings.primaryColor, portalSettings.secondaryColor, '#e15759', '#76b7b2', '#59a14f', '#edc949',
        '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab' // Add more if needed
    ];

    const data = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: backgroundColors.slice(0, values.length),
            borderWidth: 1,
        }]
    };

    const options = {
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.label || '';
                        const val = context.parsed;
                        return `${label}: ${val.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        })}`;
                    }
                }
            }
        }
    };

    return (
        <div style={{ position: 'relative', width: '300px', height: '300px', margin: '0 auto' }}>
            <div className="custom-legend" style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '1rem',
                gap: '1.5rem',
                flexWrap: 'wrap'
            }}>
                {labels.map((label, index) => (
                    <div
                        key={index}
                        onMouseEnter={(e) => {
                            const value = values[index];
                            setLegendTooltip({
                                show: true,
                                label,
                                value,
                                x: e.pageX + 10,
                                y: e.pageY + 10
                            });
                        }}
                        onMouseMove={(e) => {
                            setLegendTooltip(prev => ({
                                ...prev,
                                x: e.pageX + 10,
                                y: e.pageY + 10
                            }));
                        }}
                        onMouseLeave={() => setLegendTooltip({ show: false })}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 500
                        }}
                    >
                        <div style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: backgroundColors[index],
                            marginRight: '8px',
                        }}></div>
                        {label}
                    </div>
                ))}
            </div>

            <Pie data={data} options={options} />

            {legendTooltip.show && (
                <div style={{
                    position: 'absolute',
                    top: legendTooltip.y,
                    left: legendTooltip.x,
                    background: 'rgba(0, 0, 0, 0.85)',
                    color: '#fff',
                    padding: '6px 10px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    pointerEvents: 'none',
                    zIndex: 9999,
                    whiteSpace: 'nowrap'
                }}>
                    {legendTooltip.label}: ${legendTooltip.value.toLocaleString()}
                </div>
            )}
        </div>
    );
};

export default PolicyValueChart;
